var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"register-login"},[_c('div',{staticClass:"container"},[_c('Header'),_c('FormLogin',{attrs:{"isAnalist":_vm.isAnalist}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }